module.exports = __webpack_public_path__ + "static/media/bankid.b352e97b.png";